window.global ||= window
import { createRoot } from "react-dom/client"
import "./index.css"
import App from "./App"
import * as serviceWorker from "./serviceWorker"
import { BrowserRouter as Router } from "react-router-dom"
import { Amplify, Hub } from "@aws-amplify/core"
import { config } from "./config"
import { Auth } from "@aws-amplify/auth"
import { DialogProvider } from "shared/src/components/DialogBox/DialogBox"
import { BrowserAgent } from "@newrelic/browser-agent/loaders/browser-agent"
import { JSErrors } from "@newrelic/browser-agent/features/jserrors"

const newRelicOptions = {
	info: {
		licenseKey: "NRJS-fb3f6999e3f6d3f8ff2",
		applicationID: process.env.VITE_NEWRELIC_APPLICATIONID || "538709222",
		beacon: "bam.eu01.nr-data.net",
		errorBeacon: "bam.eu01.nr-data.net",
		account: "3875837",
	},
	init: {
		distributed_tracing: { enabled: true },
		privacy: { cookies_enabled: true },
		ajax: { enabled: true },
		session_trace: { enabled: false },
		page_view_timing: { enabled: true },
	},
	features: [JSErrors],
}

// Initialize the Browser Agent
let newRelicbrowserAgent = new BrowserAgent(newRelicOptions)

Hub.listen("auth", async ({ payload }) => {
	//This is to handle the first login with a 3rd part IDP
	//Because we remove the IDP user in the lambda and link it we neeed to restart auth.
	if (
		payload.event === "customState_failure" &&
		payload.data.message === "PostConfirmation+failed+with+error+Account+Linked.You+need+to+sign+in+again.+"
	) {
		await Auth.signOut({ global: true })
		window.location.href = `${window.origin}?login_with_sso=true`
	}

	// if (payload.event === "parsingCallbackUrl") {
	// 	console.log("hub callback")
	// moved query string rewrite to script in head to completely avoid amplify trickery
	// if (
	// 	window.location.pathname !== "/" &&
	// 	(window.location.href.includes("?code=") || window.location.href.includes("&code="))
	// ) {
	// 	window.location.href = window.location.href.replace("?code=", "?x-code=").replace("&code=", "&x-code=")
	// }
	// }

	if (payload.event === "customOAuthState") {
		if (window.location.href.includes("?x-code=") || window.location.href.includes("&x-code=")) {
			// prevent the page from reloading when redirected
			return
		}
		if (payload.data !== "") {
			const urlParams = new URLSearchParams(payload.data)
			urlParams.delete("login_with_sso")
			window.location.href = `${window.origin}?${urlParams.toString()}`
		}
	}
})

Amplify.configure({
	Auth: {
		mandatorySignIn: true,
		region: config.cognito.REGION,
		identityPoolId: config.cognito.IDENTITY_POOL_ID,
		userPoolId: config.cognito.USER_POOL_ID,
		userPoolWebClientId: config.cognito.APP_CLIENT_ID,
		oauth: {
			domain: config.cognito.DOMAIN,
			scope: ["email", "profile", "openid", "aws.cognito.signin.user.admin"],
			redirectSignIn: window.location.origin,
			redirectSignOut: window.location.origin,
			responseType: "code",
		},
	},
	Storage: {
		region: config.s3.REGION,
		bucket: config.s3.BUCKET,
		identityPoolId: config.cognito.IDENTITY_POOL_ID,
	},
	API: {
		endpoints: [
			{
				name: config.apiGateway.NAME,
				endpoint: config.apiGateway.URL,
				region: config.apiGateway.REGION,
			},
			{
				name: config.apiGatewayPublic.NAME,
				endpoint: config.apiGatewayPublic.URL,
				region: config.apiGatewayPublic.REGION,
			},
			{
				name: config.apiGatewayCustomPublic.NAME,
				endpoint: config.apiGatewayCustomPublic.URL,
				region: config.apiGatewayCustomPublic.REGION,
			},
			{
				name: config.apiGatewayLinks.NAME,
				endpoint: config.apiGatewayLinks.URL,
				region: config.apiGatewayLinks.REGION,
			},
		],
	},
})

createRoot(document.getElementById("root")).render(
	<Router>
		<DialogProvider>
			<App />
		</DialogProvider>
	</Router>
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
